import {TripCollection} from "../Trip";
import fagaras from "../../../assets/child/fagaras.jpg";

const dayChildFagaras: TripCollection = {
    imageSrc: fagaras,
    trips: [
        {
            name: "6.1. Ţara Făgăraşului I",
            route: "Braşov – Făgăraş – Sâmbăta de Sus – Ohaba – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Făgăraş",
                    },
                    {
                        locationName: "Mănăstirea Sâmbăta de Sus",
                    },
                    {
                        locationName: "Moara din Ohaba",
                    },
                ]
            ],
            notes: "Excursia oferă o combinație fascinantă între istorie, spiritualitate și patrimoniu rural. Vizita începe cu Cetatea Făgăraș, una dintre cele mai bine conservate fortificații medievale din România, care oferă o incursiune captivantă în viața și istoria medievală a regiunii. Urmează Mănăstirea Sâmbăta de Sus, lăcaș de cult deosebit, ce impresionează prin arhitectura sa și atmosfera de liniște și spiritualitate. Excursia se încheie în satul Ohaba, cu vizitarea Morii tradiționale, un exemplu al patrimoniului rural și al tehnicilor vechi de prelucrare a cerealelor, care reflectă viața autentică a comunităților transilvănene."
        },
        {
            name: "6.2. Ţara Făgăraşului II",
            route: "Braşov – Făgăraş – Sâmbăta de Sus – Ohaba – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Făgăraş",
                    },
                    {
                        locationName: "Herghelia Sâmbăta de Jos",
                    },
                    {
                        locationName: "Mănăstirea Sâmbăta de Sus",
                    },
                    {
                        locationName: "Moara din Ohaba",
                    },
                ]
            ],
            notes: "Excursia oferă o călătorie completă prin istoria, cultura și tradițiile Transilvaniei. Vizitatorii descoperă Cetatea Făgăraș, una dintre cele mai impresionante fortificații medievale din România, ce păstrează atmosfera autentică a epocii. La Herghelia Sâmbăta de Jos, pasionații de cai pot admira frumusețea și grația exemplarelor de rasă, descoperind în același timp tradiția hipică locală. Urmează Mănăstirea Sâmbăta de Sus, un lăcaș de cult ce impresionează prin arhitectura sa și liniștea sa aparte. Excursia se încheie în satul Ohaba, cu vizitarea Morii tradiționale, simbol al vieții rurale și al meșteșugului vechi, oferind o experiență autentică a Transilvaniei."
        },
        {
            name: "6.3. Ţara Făgăraşului III",
            route: "Braşov – Făgăraş – Sâmbăta de Sus – Şinca Veche – Ohaba – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Făgăraş",
                    },
                    {
                        locationName: "Mănăstirea Sâmbăta de Sus",
                    },
                    {
                        locationName: "Mănăstirea Rupestră Şinca Veche",
                    },
                    {
                        locationName: "Moara din Ohaba",
                    },
                ]
            ],
            notes: "Excursia oferă o experiență completă în inima Transilvaniei, îmbinând istoria, spiritualitatea și patrimoniul rural. Vizitatorii încep cu Cetatea Făgăraș, una dintre cele mai bine conservate fortificații medievale din România, care păstrează atmosfera autentică a Evului Mediu. Urmează Mănăstirea Sâmbăta de Sus, lăcaș de cult impresionant prin arhitectura sa și atmosfera de liniște, urmată de Mănăstirea Rupestră Șinca Veche, un monument unic sculptat în piatră, ce fascinează prin mister și autenticitate. Excursia se încheie în satul Ohaba, cu vizitarea Morii tradiționale, simbol al meșteșugului vechi și al vieții rurale transilvănene, oferind o experiență completă și autentică a regiunii."
        },
        {
            name: "6.4. Ţara Făgăraşului IV",
            route: "Braşov – Făgăraş – Şinca Veche – Ohaba – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Făgăraş",
                    },
                    {
                        locationName: "Mănăstirea Rupestră Şinca Veche",
                    },
                    {
                        locationName: "Moara din Ohaba",
                    },
                ]
            ],
            notes: "Descoperă istoria și tradițiile Transilvaniei printr-o excursie plină de obiective remarcabile. Vizitatorii încep cu Cetatea Făgăraș, una dintre cele mai bine conservate fortificații medievale din România, care păstrează farmecul și atmosfera Evului Mediu. Urmează Mănăstirea Rupestră Șinca Veche, un monument unic sculptat în piatră, ce impresionează prin mister și autenticitate. Excursia se încheie în satul Ohaba, cu vizitarea Morii tradiționale, simbol al meșteșugului vechi și al vieții rurale, oferind o experiență completă și autentică a regiunii."
        },
    ]
}

export default dayChildFagaras;